import type { KeyboardEvent } from 'react';

export function submitOnEnter(
  event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  submit: () => void,
): void {
  if (
    event.key !== 'Enter' || event.shiftKey ||
    event.nativeEvent.isComposing || event.nativeEvent.keyCode === 229
  ) return;

  event.preventDefault();
  if (!event.repeat) submit();
}
